export const MentionVariants = {
  Here: 'here',
  Everyone: 'everyone',
};
